export const siteInfo = {
  name: '吃瓜今日',
  tagline: '瓜田深处的蛛丝马迹，一次给你扒清楚',
  intro:
    '吃瓜今日深挖频道，专扒瓜田底下的暗线和蛛丝马迹。内幕线索、扒皮细节、前后矛盾点都给你整理出来，适合想比路人多吃一层瓜的进阶吃瓜群众。',
};

export const navLinks = [
  { label: '今日热瓜', href: '#hot' },
  { label: '深挖档案', href: '#dive' },
  { label: '蛛丝马迹', href: '#clue' },
  { label: '瓜田分类', href: '#category' },
  { label: '吃瓜指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export const heroStats = [
  { value: '1200+', label: '深挖档案' },
  { value: '30000+', label: '线索梳理' },
  { value: '480万', label: '瓜友足迹' },
  { value: '24h', label: '热瓜追踪' },
];

export const hotTopics = [
  {
    rank: 1,
    title: '某一线小花生日宴，前后场镜头为何对不上时间？',
    tag: '综艺现场',
    views: '128.6万',
    trend: 'up',
    summary: '同一场生日直播，粉丝拍到的手腕手表与官方镜头对不上，疑点从三分钟开始出现。',
    color: 'primary',
  },
  {
    rank: 2,
    title: '古装剧组路透里，男二的衣服到底换没换？',
    tag: '影视吃瓜',
    views: '96.3万',
    trend: 'up',
    summary: '连续三天的路透里腰带扣型时有时无，网友翻出妆造组旧照开始逐一比对。',
    color: 'primary',
  },
  {
    rank: 3,
    title: '选秀节目投票页面，凌晨三点的票数波动正常吗？',
    tag: '饭圈疑云',
    views: '81.9万',
    trend: 'flat',
    summary: '截图显示某选手票数在非活跃时段出现每分钟千级跳增，程序或人工存疑。',
    color: 'accent',
  },
  {
    rank: 4,
    title: '歌手巡演加场官宣前，为何先被黄牛刷出海报？',
    tag: '行业观察',
    views: '62.4万',
    trend: 'up',
    summary: '高清海报在正式官宣前两小时外流，水印编号与内部审核单高度一致。',
    color: 'secondary',
  },
  {
    rank: 5,
    title: '热播剧大结局放出后，编剧旧采访里的"删改线"',
    tag: '影视吃瓜',
    views: '47.8万',
    trend: 'down',
    summary: '三年前一次电台访谈中的片段被重新翻出，与最终结局存在多处对不上的设定。',
    color: 'secondary',
  },
  {
    rank: 6,
    title: '品牌代言图海报背景，修图师为何漏了那个倒影？',
    tag: '细节扒皮',
    views: '39.1万',
    trend: 'flat',
    summary: '代言官图背景玻璃里的倒影与前景站位不一致，被眼尖网友放大八倍找了出来。',
    color: 'secondary',
  },
];

export const deepDives = [
  {
    id: 1,
    title: '一场"凌晨热搜"的完整时间线复盘',
    category: '事件复盘',
    author: '瓜田侦探组',
    date: '2026-09-05',
    readTime: '8 分钟',
    image:
      'https://readdy.ai/api/search-image?query=editorial%20newsroom%20timeline%20moodboard%20with%20red%20tape%2C%20newsprint%20clippings%2C%20magnifier%20and%20clock%20collage%2C%20warm%20cream%20background%2C%20flat%20lay%20photography%2C%20soft%20even%20lighting%2C%20analog%20journalism%20aesthetic&width=900&height=600&seq=chigua-deep-1&orientation=landscape',
    excerpt:
      '从晚上十点出现零散截图，到次日九点舆论翻转，我们把每一个关键节点按分钟切开，还原事件真正发酵的顺序。',
  },
  {
    id: 2,
    title: '那张模糊路透图，放大八倍后藏着什么？',
    category: '细节扒皮',
    author: '显微镜小队',
    date: '2026-09-03',
    readTime: '6 分钟',
    image:
      'https://readdy.ai/api/search-image?query=magnifying%20glass%20over%20newspaper%20page%20and%20photographic%20prints%20on%20warm%20beige%20table%2C%20detective%20investigation%20flat%20lay%2C%20red%20marker%20highlights%2C%20soft%20natural%20window%20light%2C%20editorial%20collage%20aesthetic&width=900&height=600&seq=chigua-deep-2&orientation=landscape',
    excerpt:
      '构图、倒影、衣领针脚，一张路透里的信息量比很多人想象得大。我们用逐帧的方式重新看了一遍。',
  },
  {
    id: 3,
    title: '前后三次采访，口述里的三个版本哪个是真的？',
    category: '话术比对',
    author: '语言分析组',
    date: '2026-08-30',
    readTime: '9 分钟',
    image:
      'https://readdy.ai/api/search-image?query=two%20microphones%20and%20transcript%20papers%20on%20cream%20background%20with%20warm%20lighting%2C%20media%20interview%20flat%20lay%2C%20red%20and%20green%20annotation%20tape%2C%20editorial%20documentary%20style&width=900&height=600&seq=chigua-deep-3&orientation=landscape',
    excerpt:
      '同一件事，在三次采访里有三种表述。我们对照原片逐句标注，找出措辞里的那点微妙不同。',
  },
  {
    id: 4,
    title: '热播剧删改与放送版的"暗线"差了多少集？',
    category: '影视吃瓜',
    author: '追剧考据团',
    date: '2026-08-26',
    readTime: '7 分钟',
    image:
      'https://readdy.ai/api/search-image?query=cinema%20clapperboard%20and%20film%20strips%20arranged%20on%20warm%20beige%20backdrop%2C%20drama%20production%20flat%20lay%2C%20red%20and%20teal%20accents%2C%20soft%20lighting%2C%20editorial%20media%20aesthetic&width=900&height=600&seq=chigua-deep-4&orientation=landscape',
    excerpt:
      '编剧早期的采访、演员的杀青照、片尾演员表顺序，都能反推出那几条被剪掉的暗线所在。',
  },
];

export const clueTimeline = [
  {
    time: '10:02',
    stage: '初现',
    icon: 'sparkling',
    text: '一条只有九秒的生日幕后花絮被放上网，第一版弹幕开始有人喊"好像少了什么"。',
    heat: 60,
  },
  {
    time: '10:47',
    stage: '放大',
    icon: 'search',
    text: '粉丝逐帧截取，发现某一帧里未上妆的手臂与成片完全对不上，放大贴图开始流传。',
    heat: 78,
  },
  {
    time: '12:30',
    stage: '对比',
    icon: 'contrast',
    text: '有人翻出同场次更早的官拍角标，两套时间码出现约四分钟偏差，成为关键证据。',
    heat: 89,
  },
  {
    time: '15:20',
    stage: '发酵',
    icon: 'fire',
    text: '多个饭圈账号同步搬运，话题标签阅读量在两小时内突破千万，讨论迅速扩散。',
    heat: 96,
  },
  {
    time: '21:00',
    stage: '回应',
    icon: 'reply',
    text: '节目方发出说明，措辞里对"现场混剪"的表态，反被网友解读出更多疑点。',
    heat: 92,
  },
];

export const contradictions = [
  {
    title: '时间线对不上',
    level: '高危疑点',
    point:
      '同一场活动，官方镜头与粉丝直拍里显示的时间锚点不一致，通常意味着画面经过了重新拼接。',
    clue: '建议先固定两侧原片的时间码再下结论。',
  },
  {
    title: '衣物配饰前后不一',
    level: '细节漏洞',
    point:
      '同一件服装在上午和下午的佩戴细节出现差异，可能指向非同一时段拍摄，或多次补录。',
    clue: '可结合妆发团队晒出的工作照交叉验证。',
  },
  {
    title: '口述版本漂移',
    level: '话术分析',
    point:
      '同一事件在不同采访中被描述成略有差异的版本，关键动词的替换往往是信息变化的切口。',
    clue: '逐句比对而非只看大意，动词最诚实地暴露改动。',
  },
  {
    title: '修图露出马脚',
    level: '视觉盲区',
    point:
      '背景倒影、地板接缝、镜面反光这些"不被注意的角落"，常是修图时最先被忽略的地方。',
    clue: '放大到裁切边缘附近找，线索往往藏在那里。',
  },
];

export const categories = [
  {
    name: '综艺现场',
    desc: '镜头外的彩排、剪辑与现场细节',
    icon: 'clapperboard',
    posts: 126,
    featured: true,
  },
  {
    name: '影视吃瓜',
    desc: '片场路透与剧集删改暗线考据',
    icon: 'film',
    posts: 208,
  },
  {
    name: '饭圈疑云',
    desc: '数据波动与应援动向观察',
    icon: 'heart',
    posts: 94,
  },
  {
    name: '细节扒皮',
    desc: '图里藏字、镜中倒影的放大镜栏目',
    icon: 'focus',
    posts: 167,
  },
  {
    name: '行业观察',
    desc: '宣发节奏与营销动作的复盘',
    icon: 'chart',
    posts: 73,
  },
  {
    name: '瓜史档案',
    desc: '事件发酵全过程的存档复盘',
    icon: 'archive',
    posts: 150,
  },
];

export const guides = [
  {
    step: '01',
    title: '先固定原片',
    desc: '找到最早、最完整的一版素材作为基准，避免在二次搬运的转码画面里浪费时间。',
  },
  {
    step: '02',
    title: '按时间码对齐',
    desc: '把官方镜头、直拍、花絮放在同一条时间轴上，偏差出现的位置就是疑点所在。',
  },
  {
    step: '03',
    title: '放大角落细节',
    desc: '别只看主角，背景倒影、首饰反光、日期水印往往是信息量最大的地方。',
  },
  {
    step: '04',
    title: '逐句比对口述',
    desc: '同一件事在不同场合被怎么讲，动词一变，事情可能就悄悄改了口径。',
  },
  {
    step: '05',
    title: '交叉验证再下结论',
    desc: '单一来源只算线索，多个独立信源彼此印证之后，才算有资格谈"结论"二字。',
  },
];

export const faqs = [
  {
    q: '吃瓜今日的内容来源是什么？',
    a: '我们所有内容均基于公开可查的路透图、节目视频、采访原片与网络公开信息进行梳理与比对，只做事实层面的整理和呈现。',
  },
  {
    q: '看到某条线索截图，为什么有的对不上？',
    a: '网络截图在二次搬运过程中可能被压缩、裁剪或替换时间码。我们建议以原片与最早发布版本为准，截图只能作为提示而非结论。',
  },
  {
    q: '深挖档案多久更新一次？',
    a: '热点事件我们会实时跟进并在 24 小时内整理成档案；常态化的系列考据则按每周固定档期更新，具体可见各栏目页。',
  },
  {
    q: '线索整理的"可信度"怎么判断？',
    a: '我们把信息分为线索、证据与结论三级：单一来源标注为线索，多信源印证升为证据，只有在证据链完整时才会给出倾向性判断。',
  },
  {
    q: '我能投稿自己发现的蛛丝马迹吗？',
    a: '可以。只要你能提供可核验的原始素材并说明发现过程，都可以通过联系方式发给我们，采用后会标注你的署名。',
  },
  {
    q: '你们的内容会涉及真实个人吗？',
    a: '我们坚持只对公开的节目内容、影像物料与行业现象做讨论，不针对任何真实个人进行揣测或指责，涉及个人的判断一律以官方回应为准。',
  },
];

export const testimonials = [
  {
    name: '一个爱吃瓜的编导',
    role: '影视从业者',
    avatar: 'A',
    quote:
      '把时间码、路透和采访串成一条线再复盘，这种讲证据的吃法比单纯看热闹有意思多了。',
    rating: 5,
  },
  {
    name: '刚入门的瓜友',
    role: '追剧常客',
    avatar: 'B',
    quote:
      '第一次有人把"怎么找疑点"讲成一套能上手的方法，而不是直接甩结论让我站队。',
    rating: 5,
  },
  {
    name: '铁杆读者',
    role: '长期关注者',
    avatar: 'C',
    quote:
      '他们的档案把每次发酵都按分钟还原，重看时能清楚看到舆论是怎么一步步被带动的。',
    rating: 4,
  },
];